/**
 * "Now Available" entry modal.
 *
 * Auto-shows on page load unless the visitor dismissed it within the last
 * 24 hours (cookie: emcitate_now_available=1). Closing the modal — via the
 * X button, the CTA button, Escape, or clicking the backdrop — sets the
 * cookie for 24 hours so the modal does not reappear.
 *
 * Respects prefers-reduced-motion: the fade-in transition is skipped when
 * the user prefers reduced motion.
 */
export function initNowAvailableModal() {
  const modal = document.querySelector('[data-emc-available-modal]');
  if (!modal) return;

  const COOKIE = 'emcitate_now_available';

  const hasCookie = () =>
    document.cookie.split(';').some((c) => c.trim().startsWith(COOKIE + '='));

  const setCookie = () => {
    const expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${COOKIE}=1; path=/; expires=${expires}; SameSite=Lax`;
  };

  const closeBtns = modal.querySelectorAll('[data-emc-available-close]');

  const close = () => {
    modal.hidden = true;
    setCookie();
  };

  const open = () => {
    if (hasCookie()) return;
    modal.hidden = false;
    // Move focus to the X button so screen-reader users hear the dialog.
    const firstClose = modal.querySelector('[data-emc-available-close]');
    firstClose?.focus();
  };

  closeBtns.forEach((btn) => btn.addEventListener('click', close));

  // Backdrop click closes.
  modal.addEventListener('click', (e) => {
    if (e.target === modal) close();
  });

  modal.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  open();
}
